import React, { createContext, useContext, useState } from 'react';

import usePopupLaunchStyles from 'components/CallScribe/popupLaunchStyles';

const AnnounceContext = createContext<(text: string) => void>(() => undefined);

export const useAnnounceLaunch = (): ((text: string) => void) => useContext(AnnounceContext);

const LaunchAnnouncer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const classes = usePopupLaunchStyles();
  const [text, setText] = useState('');

  return (
    <AnnounceContext.Provider value={setText}>
      {children}
      <div className={classes.liveRegion} aria-live="polite" aria-atomic="true">
        {text}
      </div>
    </AnnounceContext.Provider>
  );
};

export default LaunchAnnouncer;
